import { useState, useEffect } from 'react';
import { type Wallet } from '@ewf/components/ModalUI/WalletSelector';
import { ConnectWC } from '@ewf/components/ConnectWC';
import { MARKETPLACE_CHAINS } from '@shared/types/enums';
import { SelectWallet } from './SelectWallet';
import { ConnectionLoading } from './ConnectionLoading';
// import { ConnectionError } from './ConnectionError';
import { ConnectionError } from '@ewf/components/ConnectUserWallet/ConnectionError';
import { useConnectionStore } from '@ewf/stores/connection';
import { ConnectPolkadot } from '@ewf/components/ConnectPolkadot';

export type Step = 'select' | 'connectWC' | 'connectLedger' | 'connectPolkadot' | 'loading' | 'error';

export const ConnectEWXWallet = ({ onConnect, onClose }: Props): JSX.Element => {
  const [step, setStep] = useState<Step>('select');
  const [isConnecting, setIsConnecting] = useState(false);
  const [errorMsg, setErrorMsg] = useState<string | undefined>();
  const walletConnectModal = useConnectionStore((state) => state.walletConnectModal);

  const goToConnectionMethod = (wallet: Wallet) => {
    if (wallet === 'wallet-connect') {
      setStep('connectWC');
    }

    if (wallet === 'ledger') setStep('connectLedger');

    if (wallet === 'polkadot') setStep('connectPolkadot');
  };

  const connectionError = (errorMsg?: string) => {
    setErrorMsg(errorMsg);
    setStep('error');
  };

  useEffect(() => {
    if (!walletConnectModal) return;

    walletConnectModal.subscribeModal((state) => {
      if (!state.open && step === 'connectWC') {
        isConnecting ? setStep('loading') : setStep('select');
      }
    });
  }, [step, isConnecting, walletConnectModal]);

  const renderStep = (): JSX.Element => {
    if (step === 'select')
      return <SelectWallet onNext={goToConnectionMethod} onClose={onClose} network={MARKETPLACE_CHAINS.EWX} />;
    if (step === 'connectWC')
      return (
        <ConnectWC
          chain={MARKETPLACE_CHAINS.EWX}
          isConnectingCallback={() => setIsConnecting(true)}
          onConnectionSuccess={onConnect}
          onConnectionError={connectionError}
        />
      );
    if (step === 'connectPolkadot')
      return (
        <ConnectPolkadot
          chain={MARKETPLACE_CHAINS.EWX}
          onClose={onClose}
          onConnectionSuccess={onConnect}
          onConnectionError={connectionError}
        />
      );
    if (step === 'loading') return <ConnectionLoading />;
    if (step === 'error') return <ConnectionError errorMsg={errorMsg} onClose={onClose} />;

    onClose();
    return <></>;
  };

  return renderStep();
};

interface Props {
  onConnect: () => void;
  onClose: () => void;
}
